import i18n from '@pureartisan/simple-i18n';
import { useEffect, useRef, useState } from 'react';
import useStore from './store.js';
import { MAP_CONTROLS_CLASSES } from './../../../constants/map';
import { DATA_FILES } from './../../../constants/map';
import { UNTD_LAYERS } from './../../../constants/layers';

var roundValue = function roundValue(num, dec) {
  return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
};

export var roundIndicatorValue = function roundIndicatorValue(val, _ref) {
  var decimals = _ref.decimals,
      percent = _ref.percent;
  return Number(percent) ? roundValue(val, decimals + 2) : roundValue(val, decimals);
};
export var formatIndicatorValue = function formatIndicatorValue(val, _ref2) {
  var _ref2$decimals = _ref2.decimals,
      decimals = _ref2$decimals === void 0 ? 1 : _ref2$decimals,
      _ref2$currency = _ref2.currency,
      currency = _ref2$currency === void 0 ? 0 : _ref2$currency,
      _ref2$percent = _ref2.percent,
      percent = _ref2$percent === void 0 ? 0 : _ref2$percent;
  var isExponent = String(val).indexOf('e') > 0;

  if (isExponent) {
    if (val < 1 && val > -1) {
      return String(Math.round(val).toPrecision(1));
    } else {
      return getRoundedValue(val, 0, true, false, false);
    }
  }

  return getRoundedValue(val, Number(decimals), true, Number(currency), Number(percent));
};
export var getIndicatorConfig = function getIndicatorConfig(indicator, activeLayerIndex) {
  var high_is_good = !!Number(indicator.highisgood);
  var currency = !!Number(indicator.currency);
  var decimals = Number(indicator.decimals);
  var alt_u = indicator.alt_u;
  var min = Number(indicator.min);
  var max = Number(indicator.max);
  var mean = Number(indicator.mean);
  var percent = !!Number(indicator.percent);
};
/**
 * Given a feature, returns the region that the feature belongs to
 * @param {*} feature
 * @returns {string}
 */

export var getRegionNameFromFeature = function getRegionNameFromFeature(feature) {
  var _feature$layer;

  if (!feature) return '';
  var regionId = (feature === null || feature === void 0 ? void 0 : feature.source) || (feature === null || feature === void 0 ? void 0 : (_feature$layer = feature.layer) === null || _feature$layer === void 0 ? void 0 : _feature$layer.source);
  var layer = UNTD_LAYERS.find(function (l) {
    return l.id === regionId;
  });
  return i18n.translate(layer.label);
};
export var getActiveLayerIndex = function getActiveLayerIndex(layers) {
  return layers.indexOf(1);
};
/**
 * Builds a sentence case string from lowercase string.
 * @param  {[type]} str [description]
 * @return {[type]}     [description]
 */

export var toSentenceCase = function toSentenceCase(str) {
  var first = str.slice(0, 1);
  var rest = str.slice(1);
  first = first.toUpperCase();
  return first + rest;
};
/**
 * Loads map features based on a string of locations
 * @param {string} locations locations formed as `{id},{lat},{lon}` separated by a `+`
 * @returns {Promise<Array<Feature>>}
 */

export var loadFeaturesFromRoute = function loadFeaturesFromRoute(locations) {
  return loadFeaturesFromCoords(parseLocationsString(locations));
};
/**
 * Loads map features from location parameter
 * @param {*} params
 * @returns {Promise<Array<Feature>>}
 */

export var loadFeaturesFromRouteParams = function loadFeaturesFromRouteParams(params) {
  return params.locations ? loadFeaturesFromRoute(params.locations) : Promise.resolve([]);
}; // export const loadFlaggedData = type => {
//   return axios.get(FLAGGED_ENDPOINT + type + '.json')
// }

/**
 * Returns the feature with an id property that matches the
 * provided ID
 * @param {string} id
 * @param {FeatureCollection} collection
 * @returns {Feature}
 */

var getFeatureFromCollection = function getFeatureFromCollection(id, collection) {
  var feature = collection.find(function (f) {
    return f.properties.id === id;
  });

  if (!feature) {
    throw new Error('feature ' + id + ' not found from tilequery API');
  }

  return feature;
};
/**
 * Converts string to title case
 * @param  String str String input
 * @return String
 */


export var toTitleCase = function toTitleCase(str) {
  str = str.toLowerCase().split(' ');

  for (var i = 0; i < str.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
  }

  return str.join(' ');
};
/**
 * Returns a value rounded to the indicated number of decimals
 * @param  String value     Number or string, value passed to function
 * @param  Number decimals  Number of decimals to round to
 * @param  Boolan padZeroes If true, pad with extra zeroes to fill empty decimal spots
 * @return Number
 */

export var getRoundedValue = function getRoundedValue(value, decimals, padZeroes, isCurrency, isPercent) {
  if (padZeroes === void 0) {
    padZeroes = false;
  }

  if (isCurrency === void 0) {
    isCurrency = false;
  }

  if (isPercent === void 0) {
    isPercent = false;
  } // console.log('getRoundedValue(), ', value)


  var type = typeof value;

  if (!!isPercent) {
    value = value * 100;
  }

  var fixed = null;

  if (type === 'string') {
    if (padZeroes) {
      fixed = parseFloat(value).toFixed(decimals).toLocaleString();
    } else {
      fixed = Number(+parseFloat(value).toFixed(decimals)).toLocaleString();
    }
  } else {
    if (padZeroes) {
      fixed = Number(value.toFixed(decimals)).toLocaleString();
    } else {
      fixed = Number(value.toFixed(decimals)).toLocaleString();
    }
  }

  if (!!isCurrency) {
    fixed = '$' + fixed;
  }

  if (!!isPercent) {
    fixed = fixed + '%';
  }

  return fixed;
};
/**
 * Returns boolean if quintile is within active quintiles
 * @param  {[type]}  quintile        [description]
 * @param  {[type]}  activeQuintiles [description]
 * @return {Boolean}                 [description]
 */

export var isInActiveQuintile = function isInActiveQuintile(quintile, activeQuintiles) {
  return true;
};
/**
 * Returns an index value for the quintile, 0 for far left, 4 for far right
 * @type {[type]}
 */

export var getQuintile = function getQuintile(value, min, max, high_is_good) {
  if (high_is_good === void 0) {
    high_is_good = 1;
  } // console.log('getQuintile()')


  var standardized = Math.abs(value - min) / Math.abs(max - min) * 100;

  switch (true) {
    case standardized >= 80:
      return high_is_good ? 4 : 0;
      break;

    case standardized < 80 && standardized >= 60:
      return high_is_good ? 3 : 1;
      break;

    case standardized < 60 && standardized >= 40:
      return 2;
      break;

    case standardized < 40 && standardized >= 20:
      return high_is_good ? 1 : 3;
      break;

    case standardized < 20 && standardized >= 0:
      return high_is_good ? 0 : 4;
      break;

    default:
      return 0;
  }
};
/**
 * Calculates hash position (percent from left/0 based on min/max)
 * @param  Number value Value of metric
 * @param  Number min   Minimum of range for metric
 * @param  Number max   Maximum of range for metric
 * @return {[type]}       [description]
 */

export var getHashLeft = function getHashLeft(value, min, max) {
  return (value - min) / (max - min) * 100;
};
/**
 * Filters an array of metrics, returns an object of metric data
 * @param  String metric string for metric
 * @return {[type]}        [description]
 */

export var getMetric = function getMetric(metric, metrics) {
  // console.log('getMetric, ', metric, metrics)
  var metricData = metrics.find(function (m) {
    return m.id === metric;
  });

  if (!!metricData) {
    return metricData;
  } else {
    return false;
  }
};
export var getQuintilesPhrase = function getQuintilesPhrase(quintiles) {
  if (!!quintiles[0] && !!quintiles[1] && !!quintiles[2] && !!quintiles[3] && !!quintiles[4]) {
    // all true, return
    return i18n.translate('ALL_FIVE') + ' ' + i18n.translate('QUINTILES');
  } else {
    var count = 0;
    var last = 0;

    for (var i = 1; i < quintiles.length; i++) {
      if (!!quintiles[i]) {
        last = i;
        count++;
      }
    }

    if (count === 0) {
      // No quintiles active
      return i18n.translate('NO') + ' ' + i18n.translate('QUINTILES');
    }

    if (count === 1) {
      // 1 quintiles active
      return i18n.translate(getQuintileDesc(last)) + ' ' + i18n.translate('QUINTILE');
    }

    var phrase = [];
    quintiles.forEach(function (el, i) {
      if (!!el) {
        phrase.push(i18n.translate(getQuintileDesc(i)));
      }
    });

    if (count === 2) {
      // 2 quintiles active
      // console.log('count is 2')
      phrase[phrase.length - 1] = i18n.translate('AND') + ' ' + phrase[phrase.length - 1];
      phrase.push(i18n.translate('QUINTILES'));
      phrase.join();
      phrase = String(phrase).replace(/,/g, ' ');
      return phrase;
    } else {
      phrase[phrase.length - 1] = i18n.translate('AND') + ' ' + phrase[phrase.length - 1];
      phrase.join(',');
      phrase = String(phrase).replace(/,/g, ', ');
      phrase = phrase + ' ' + i18n.translate('QUINTILES');
      return phrase;
    }
  }
};
/**
 * Returns string placeholder based on quintile provided
 * @param  Number quintile Quintile 0 - 4
 * @return String          String referncing translation file constant
 */

export var getQuintileDesc = function getQuintileDesc(quintile) {
  switch (true) {
    case quintile === 0:
      {
        return 'FIRST';
      }

    case quintile === 1:
      {
        return 'SECOND';
      }

    case quintile === 2:
      {
        return 'THIRD';
      }

    case quintile === 3:
      {
        return 'FOURTH';
      }

    case quintile === 4:
      {
        return 'FIFTH';
      }
  }
};
/**
 * Gets a property from a feature, returns null if not found
 * @param {Feature} feature GeoJSON feature
 * @param {string} propName property name to grab
 */

export var getFeatureProperty = function getFeatureProperty(feature, propName) {
  if (feature && feature.properties && feature.properties[propName] !== -999) {
    return feature.properties[propName];
  }

  return null;
};
/**
 * Returns the feature type (from feature.source)
 */

export var getFeatureType = function getFeatureType(feature) {
  return feature && feature.source ? feature.source : null;
};
/**
 * Gets feature source
 * @param  {[type]} feature [description]
 * @return {[type]}         [description]
 */

export var getFeatureSource = function getFeatureSource(feature) {
  if (!!feature && !!feature.source) {
    if (feature.source.indexOf('points') > -1) {
      return 'points';
    } else {
      return feature.source;
    }
  } else {
    return null;
  } // return feature && feature.source ? feature.source : null

};
/**
 * [getFeatureTypeInfo description]
 * @param  {[type]} feature [description]
 * @return {[type]}         [description]
 */

export var getFeatureTypeObj = function getFeatureTypeObj(feature) {
  var source = getFeatureSource(feature); // Points features are in a different config object
  // (loaded locally) than the layers, which exist as
  // remote sources.

  if (source && source.indexOf('points') > -1) {
    return source ? DATA_FILES.find(function (el) {
      return el.id === source;
    }) : null;
  } else {
    return source ? UNTD_LAYERS.find(function (el) {
      return el.id === source;
    }) : null;
  }
};
export var getFeatureId = function getFeatureId(feature) {
  var source = getFeatureSource(feature); // if (source && source.indexOf('points') > -1) {
  //   return feature.properties.FID
  // } else {

  var info = getFeatureTypeObj(feature);
  return feature.properties[info.id_key]; // }
}; // export const generateFeatureId = feature => {
//   const lat = Math.round(
//     Math.abs(feature.properties.Latitude) * 10000000,
//   )
//   const lng = Math.round(
//     Math.abs(feature.properties.Longitude) * 10000000,
//   )
//   const id = Number(String(lng) + String(lat))
//   return id
// }

/**
 * Returns feature Id from properties field identified in
 * data map.
 */
// export const getFeatureId = feature => {
//   // console.log('getFeatureId, ', feature)
//   if (feature.layer.source === 'points') {
//     // Calculate an ID for the point based on its latlng,
//     // because no ID is provided by the feature.
//     const id = generateFeatureId(feature)
//     return id
//   } else {
//     const info = getFeatureTypeObj(feature)
//     return feature.properties[info.id_key]
//   }
// }

/**
 * Returns feature label from a properties field
 * designated in data map.
 */

export var getFeatureLabel = function getFeatureLabel(feature) {
  var info = getFeatureTypeObj(feature);
  return !!info ? feature.properties[info.label_key] : null;
};
export var isFeaturePoint = function isFeaturePoint(feature) {
  return feature.geometry.type === 'Point';
};
/**
 * Gets a property from a feature, returns null if not found
 * @param {Feature} feature GeoJSON feature
 * @param {string} propName property name to grab
 */

export var getFeaturePropertyFromSet = function getFeaturePropertyFromSet(feature, propName) {
  DATA_FILES;

  if (feature && feature.properties && feature.properties[propName] !== -999) {
    return feature.properties[propName];
  }

  return null;
}; // Hook

export var usePrevious = function usePrevious(value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  var ref = useRef(); // Store current value in ref

  useEffect(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
}; // https://dev.to/gabe_ragland/debouncing-with-react-hooks-jci

export var useDebounce = function useDebounce(value, delay) {
  // State and setters for debounced value
  var _useState = useState(value),
      debouncedValue = _useState[0],
      setDebouncedValue = _useState[1];

  useEffect(function () {
    // Set debouncedValue to value (passed in) after the specified delay
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay); // Return a cleanup function that will be called every time ...
    // ... useEffect is re-called. useEffect will only be re-called ...
    // ... if value changes (see the inputs array below).
    // This is how we prevent debouncedValue from changing if value is ...
    // ... changed within the delay period. Timeout gets cleared and restarted.
    // To put it in context, if the user is typing within our app's ...
    // ... search box, we don't want the debouncedValue to update until ...
    // ... they've stopped typing for more than 500ms.

    return function () {
      clearTimeout(handler);
    };
  }, // Only re-call effect if value changes
  // You could also add the "delay" var to inputs array if you ...
  // ... need to be able to change that dynamically.
  [value, delay]);
  return debouncedValue;
}; // https://gomakethings.com/how-to-get-the-closest-parent-element-with-a-matching-selector-using-vanilla-javascript/

export var getClosest = function getClosest(elem, selector) {
  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;

      while (--i >= 0 && matches.item(i) !== this) {}

      return i > -1;
    };
  } // Get the closest matching element


  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }

  return null;
}; // Get all parents of an element.
// https://gomakethings.com/how-to-get-all-parent-elements-with-vanilla-javascript/

export var getParents = function getParents(elem) {
  // Set up a parent array
  var parents = []; // Push each parent element to the array

  for (; elem && elem !== document; elem = elem.parentNode) {
    parents.push(elem);
  } // Return our parent array


  return parents;
};
/**
 * Check whether or not a control is hovered,
 * based on an array of class selectors.
 */

export var checkControlHovered = function checkControlHovered() {
  // console.log('checkControlHovered()')
  var hoveredElements = document.querySelectorAll(':hover');
  var parents = [];
  hoveredElements.forEach(function (el) {
    parents.push(getParents(el));
  });
  var parentsList = Object.values(parents);
  var nodeList = Object.values(hoveredElements);
  var isControl = nodeList.some(function (node) {
    // console.log('node, ', node, node.classList)
    return MAP_CONTROLS_CLASSES.some(function (item) {
      return node.classList.contains(item);
    });
  }) || parentsList.some(function (node) {
    // console.log('node, ', node, node.classList)
    return MAP_CONTROLS_CLASSES.some(function (item) {
      return node && node.classlist && node.classList.contains(item);
    });
  }); // console.log('isControl, ', isControl)

  return isControl;
};
/**
 * Returns a feature label specific to the feature type.
 * @param Object feature
 * @returns String
 */

export var getGeoFeatureLabel = function getGeoFeatureLabel(feature) {
  if (!feature) return 'Unknown';
  var source = UNTD_LAYERS.find(function (item) {
    return item.id === feature.source;
  });
  var layerID = feature.layer.source;
  var label = feature.properties[source.label_key] ? feature.properties[source.label_key] : false;

  switch (layerID) {
    case 'zip':
      return i18n.translate("TOOLTIP_PLACE_ZIP", {
        label: label
      });

    case 'place':
      return "" + label;

    case 'tract':
      return i18n.translate("TOOLTIP_PLACE_TRACT", {
        label: label
      });

    case 'county':
      return i18n.translate("TOOLTIP_PLACE_COUNTY", {
        label: label
      });

    default:
      return 'unknown';
  }
};
export var setActiveQuintile = function setActiveQuintile(quintile) {
  // console.log('setActiveQuintile, ', quintile)
  var arr = [0, 0, 0, 0, 0];
  arr[quintile] = 1; // console.log(arr)

  return arr;
};
export var replaceWeirdQuestionmark = function replaceWeirdQuestionmark(str) {
  return str.replaceAll('�', '');
};
/** Returns true if value has is numeric */

export var hasValue = function hasValue(value) {
  return (value || value === 0) && !isNaN(value);
};
export var setFocus = function setFocus(selector) {
  var el = document.querySelector(selector);
  if (el) el.focus();
};